import React from 'react';
import Styled from './styled';

interface Props {
  onClick?: () => void;
  text: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  href?: string;
}

const Button: React.FC<Props> = ({ onClick, text, icon, disabled = false, type = 'button', className }) => {

  return (
    <Styled.Button
      type={type}
      onClick={onClick}
      className={className}
      disabled={disabled}
    >
      <span>{icon} {text}</span>
    </Styled.Button>
  );
};

export default Button;
